import { cva, type VariantProps } from "class-variance-authority";
import { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

const variants = cva(
  "relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive:
          "border-destructive/50 text-destructive dark:text-destructive-foreground/80 dark:border-destructive [&>svg]:text-current dark:bg-destructive/50",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

type AlertProps = ComponentProps<"div"> & VariantProps<typeof variants>;
type AlertTitleProps = ComponentProps<"div">;
type AlertDescriptionProps = ComponentProps<"div">;

export const Alert: FC<AlertProps> = ({ className, variant, ...props }) => (
  <div
    data-slot="alert"
    role="alert"
    className={cn(variants({ variant }), className)}
    {...props}
  />
);

export const AlertTitle: FC<AlertTitleProps> = ({ className, ...props }) => (
  <div
    data-slot="alert-title"
    className={cn(
      "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
      className,
    )}
    {...props}
  />
);

export const AlertDescription: FC<AlertDescriptionProps> = ({
  className,
  ...props
}) => (
  <div
    data-slot="alert-description"
    className={cn(
      "col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed",
      className,
    )}
    {...props}
  />
);
